/* External */
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import { compose } from 'redux';

/* Utils */
import { withOnEnterPressAsMouseDownHandler } from './withOnEnterPressAsMouseDownHandler.hoc';
import { withCursorVisibilityFilter } from './withCursorVisibilityFilter.hoc';
import { withFocusableClassName } from './withFocusableClassName.hoc';
import { withFocusRestorable } from '../providers/RestoreFocusProvider';

export default function withInteractiveFocusable(options) {
  return compose(
    withOnEnterPressAsMouseDownHandler,
    withFocusable(options),
    withCursorVisibilityFilter,
    withFocusableClassName,
    withFocusRestorable,
  );
}
